export function important_notice() {
  if($('#notice-close-btn').length) {
    $('#notice-close-btn').click(()=> {
      $('.important-notice').addClass('hide');
      let now = new Date();
      let time = now.getTime();
      time += 3600 * 3000;
      now.setTime(time);
      document.cookie = `important_notice=${true}; path=/; expires=${now.toUTCString()}`;
    });
  }
}
